var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivesessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5625 3C43.5 3 48 7.5 48 14.4375V39.5625C48 46.5 43.5 51 36.5625 51H11.4375C4.5 51 0 46.5 0 39.5625V14.4375C0 7.5 4.5 3 11.4375 3H36.5625Z",
    fill: "url(#paint0_linear_2522_18131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7726 15.2689C15.7726 14.9609 15.895 14.6656 16.1128 14.4478C16.3306 14.23 16.6259 14.1077 16.9339 14.1077H30.869C31.177 14.1077 31.4723 14.23 31.6901 14.4478C31.9079 14.6656 32.0303 14.9609 32.0303 15.2689V38.4941C32.0303 38.8021 31.9079 39.0974 31.6901 39.3152C31.4723 39.533 31.177 39.6553 30.869 39.6553H16.9339C16.6259 39.6553 16.3306 39.533 16.1128 39.3152C15.895 39.0974 15.7726 38.8021 15.7726 38.4941V15.2689ZM16.9339 11.7852C16.01 11.7852 15.1238 12.1522 14.4705 12.8055C13.8172 13.4589 13.4501 14.345 13.4501 15.2689V38.4941C13.4501 39.418 13.8172 40.3041 14.4705 40.9575C15.1238 41.6108 16.01 41.9778 16.9339 41.9778H30.869C31.7929 41.9778 32.6791 41.6108 33.3324 40.9575C33.9857 40.3041 34.3528 39.418 34.3528 38.4941V15.2689C34.3528 14.345 33.9857 13.4589 33.3324 12.8055C32.6791 12.1522 31.7929 11.7852 30.869 11.7852H16.9339ZM20.4177 36.5199C20.2021 36.5199 19.9953 36.6056 19.8429 36.758C19.6904 36.9105 19.6048 37.1172 19.6048 37.3328C19.6048 37.5484 19.6904 37.7552 19.8429 37.9076C19.9953 38.0601 20.2021 38.1457 20.4177 38.1457H27.3852C27.6008 38.1457 27.8076 38.0601 27.96 37.9076C28.1125 37.7552 28.1981 37.5484 28.1981 37.3328C28.1981 37.1172 28.1125 36.9105 27.96 36.758C27.8076 36.6056 27.6008 36.5199 27.3852 36.5199H20.4177Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2522_18131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0003 16C34.6572 16 36.0003 14.6569 36.0003 13C36.0003 11.3431 34.6572 10 33.0003 10C31.3435 10 30.0003 11.3431 30.0003 13C30.0003 14.6569 31.3435 16 33.0003 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9527 13C34.9527 14.0782 34.0786 14.9523 33.0003 14.9523C31.9221 14.9523 31.048 14.0782 31.048 13C31.048 11.9218 31.9221 11.0477 33.0003 11.0477C34.0786 11.0477 34.9527 11.9218 34.9527 13Z",
    stroke: "white",
    strokeWidth: 2.09534
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2522_18131",
    x: 20.0003,
    y: -0.00000166893,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2522_18131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2522_18131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2522_18131",
    x1: 0,
    y1: 3,
    x2: 0,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B33C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivesessions);
export default __webpack_public_path__ + "static/media/activesessions.3499da35f60d3366ff6362a339ddfd2a.svg";
export { ForwardRef as ReactComponent };